/* eslint-disable react-hooks/exhaustive-deps */
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDoc,
    getDocs,
    onSnapshot,
    orderBy,
    query,
    serverTimestamp,
    updateDoc,
    where,
} from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { PaymentFacture } from "./paymentFacture.type";
import { useLocationState } from "../../Utils";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Facture , factureStatut } from "../facture/facture.type";


export const PaymentFactureApi = createApi({
    reducerPath: "paymentFactureApi",
    tagTypes: ["paymentFacture"],
    baseQuery: fakeBaseQuery(),
    endpoints: (builder) => ({
        addOrEditPaymentFacture: builder.mutation({
            async queryFn({ id, ...data }) {
                try {
                    const user = auth.currentUser;
                    if (!user) {
                        return { error: { message: "Aucun utilisateur connecté." } };
                    }
                    const userId = user?.uid;
                    if (!id) {

                        // 1. Ajouter le paiement
                        const docRef = await addDoc(collection(db, "paymentFactures"), {
                            ...data,
                            createdAt: serverTimestamp(),
                            createdBy: userId,
                            updatedAt: serverTimestamp()
                        });

                        // 2. Récupérer la facture actuelle
                        const factureRef = doc(db, "factures", data.factureId);
                        const factureSnap = await getDoc(factureRef);
                        const facture = factureSnap.data() as Facture;

                        // 3. Calculer le nouveau montantVerse (cumul)
                        const nouveauMontantVerse = (facture.montantVerse || 0) + parseInt(data.montant);

                        // 4. Déterminer le statut
                        let statut: factureStatut;
                        if (nouveauMontantVerse <= 0) {
                            statut = "not_paid";
                        } else if (nouveauMontantVerse < facture.montant) {
                            statut = "partially_paid";
                        } else {
                            statut = "paid";
                        }

                        // 5. Mettre à jour la facture
                        await updateDoc(factureRef, {
                            montantVerse: nouveauMontantVerse,
                            statut,
                            datePaiement: data.datePaiement,  // date du dernier paiement ajouté
                            updatedAt: serverTimestamp()
                        });

                        return {
                            data: {
                                id: docRef.id,
                                message: "Paiement ajouté !",
                                ...data,
                            },
                        };

                    } else {
                        // Mettre à jour Firestore

                        const compRef = doc(db, "paymentFactures", id);
                        await updateDoc(compRef, { 
                            ...data, 
                            updatedAt: serverTimestamp() 
                        });

                        return {
                            data: {
                                message:
                                    "Paiement modifié !",
                            },
                        };
                    }
                } catch (error: any) {
                    return { error: { status: "CUSTOM", message: error.message } };
                }
            },
            invalidatesTags: ["paymentFacture"],
        }),
        getPaymentFactureById: builder.query({
            queryFn: async (FactureId) => {
                try {
                    const FactureRef = doc(db, "paymentFactures", FactureId);
                    const FactureSnap = await getDoc(FactureRef);

                    if (!FactureSnap.exists()) {
                        return {
                            error: { status: 404, message: "Évaluation introuvable !" },
                        };
                    }

                    return { data: { id: FactureSnap.id, ...FactureSnap.data() } };
                } catch (error: any) {
                    return { error: { status: 500, message: error.message } };
                }
            },
            providesTags: ["paymentFacture"],
        }),
         // Supprimer
        deletePaymentFacture: builder.mutation({
            queryFn: async (uid) => {
                try {
                    const docRef = doc(db, "paymentFactures", uid);
                    await deleteDoc(docRef);
                    return {
                        data: { uid, message: "Paiement supprimée !", success: true },
                    };
                } catch (error: any) {
                    return { error: { status: "DELETE_ERROR", message: error.message } };
                }
            },
            invalidatesTags: ["paymentFacture"],
        }),


    }),
});

export const {
    useAddOrEditPaymentFactureMutation,
    useDeletePaymentFactureMutation,
    useLazyGetPaymentFactureByIdQuery,
} = PaymentFactureApi;

export function usePaymentFactureFromLocation(): [
    PaymentFacture,
    boolean,
    string,
    (id: string) => any
] {
    const itemState = useLocationState<PaymentFacture | undefined>(undefined);
    const [item, setItem] = useState(itemState);
    const { id } = useParams<{ id: string }>();
    const [findById, { data, isError, isLoading }] = useLazyGetPaymentFactureByIdQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            findById(id as string);
        }
    }, [id]);
    useEffect(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    useEffect(() => {
        if (data) {
            setItem(data as PaymentFacture);
        }
    }, [data]);

    return [item as PaymentFacture & { bio: string }, isLoading, id as string, findById];
}

